export const createSecureUuid = (cryptoApi = globalThis.crypto) => {
  if (typeof cryptoApi?.randomUUID === "function") return cryptoApi.randomUUID();
  if (typeof cryptoApi?.getRandomValues !== "function") {
    const error = new Error("This browser cannot generate secure attendance identifiers. Update your browser or open the HTTPS attendance site in a supported browser, then retry.");
    error.attendanceCode = "SECURE_CRYPTO_UNAVAILABLE";
    throw error;
  }

  const bytes = new Uint8Array(16);
  cryptoApi.getRandomValues(bytes);
  bytes[6] = (bytes[6] & 0x0f) | 0x40; // RFC 4122 version 4.
  bytes[8] = (bytes[8] & 0x3f) | 0x80; // RFC 4122 variant 10xx.
  const hex = Array.from(bytes, byte => byte.toString(16).padStart(2, "0"));
  return `${hex.slice(0, 4).join("")}-${hex.slice(4, 6).join("")}-${hex.slice(6, 8).join("")}-${hex.slice(8, 10).join("")}-${hex.slice(10).join("")}`;
};
